export enum DividerVariations {
  d360 = 'divider360',
  d360TripleBackflip = 'divider360TripleBackflip',
  d360DownArrow = 'divider360DownArrow',
  tripleArrowDown = 'dividerTripleArrowDown',
}
